import { createLazyComponent, LazyModule, LazyImport, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RWFeedbackFooter" */ './lazyIndex')
);

export let FeedbackFooter = createLazyComponent(lazyModule, m => m.FeedbackFooter);
export let lazyRemovePendingRequestCorrelationId = new LazyAction(
    lazyModule,
    m => m.removePendingRequestCorrelationId
);
export let lazyAddPendingRequestCorrelationId = new LazyAction(
    lazyModule,
    m => m.addPendingRequestCorrelationId
);
export const lazyShowFeedbackDialog = new LazyImport(lazyModule, m => m.showFeedbackDialog);
